import React from "react";
import LazyLoad from 'react-lazyload';
import ProductItem from './ProductItem';
class ContentProducts extends React.Component {
  constructor(props) {
    super(props);
  }
  addToCart=(product)=>{
    this.props.addToCart(product);
  }

  render() {
    let {products} = this.props,
    productsItemView = "";
    if(products)
    {
      productsItemView = products.map((product, idx)=>{
        return(
          <LazyLoad key={idx} height={200}>
            <ProductItem addToCart={this.addToCart} product={product} />
          </LazyLoad>
        )
      });  
    }
    return (
      <div className="row pb-2 pb-md-3">
        <div className="col-12 mt-4">
        <p>Tổng: <strong className="text-info">{products.length}</strong> sản phẩm</p>
        <hr/>
        </div>
        <div className="product-wrap d-flex justify-content-start w-100">
            {productsItemView}
        </div>
      </div>
    );
  }
}
export default ContentProducts;
